// extracted by mini-css-extract-plugin
export default {"root":"RentEventHomePage_root__r00ii","main":"RentEventHomePage_main__4ZHr7"};